import React from 'react'
import {Link} from 'react-router-dom'
import {SignInLayout} from './SignInLayout'
import {Button} from 'startlibs/lib/components'
import {withForm, Errors, Form, TextInput} from 'startlibs/lib/form'
import {formFetch} from 'startlibs'
import {withToggles} from 'startlibs/lib/hocs'
import {buildValidation, emailValidation, responseFailure} from '../lib/validation'
import {logout} from '../reducers'
import {connect} from 'react-redux'

@withForm(formFetch)
@withToggles('successFeedback','isLoggingOut')
@connect(undefined,{logout})
class PasswordRecoveryContent extends React.Component {

  onFailure = responseFailure(this.props.form,({message,title}) =>
    (message === "Invalid e-mail, retry typing or sign up." && {email:[message]}) ||
    (title === "Email address not registered" && {email: [<React.Fragment>No Horos Cloud account found using this e-mail. <Link to="signUp">Sign up</Link> or try using a different e-mail.</React.Fragment>]})
  )

  preValidation = buildValidation({
      email: emailValidation
    },
    _ => _.email
  )

  onSuccess = () => {
    this.props.isLoggingOut.open()
    this.props.logout()
      .catch(()=>0)
      .then(()=>{
        this.props.successFeedback.open();
        this.props.isLoggingOut.close();
        this.props.form.connector.setValue('email','')
      })
  }

  trySubmit = (e) => {
    e.preventDefault()
    this.props.successFeedback.close()
    if (!this.props.form.isLoading && !this.props.isLoggingOut.isOpen) {
      this.props.form.connector.submitProperties()
    }
  }

  render() {
    const {form, isLoggingOut, successFeedback} = this.props
    return (
      <div>
        <div className="opening-section">
          <h1>Horos Cloud password recovery</h1>
          <h3>Fill in bellow and we'll send a recovery link to your e-mail</h3>
        </div>
        <Form url="/api/account/reset-password/init" preValidation={this.preValidation}
              onFailure={this.onFailure}
              onSuccess={this.onSuccess}
              onSubmit={this.trySubmit}
              form={form}
        >
          <TextInput
            tabIndex={1}
            label="E-mail:"
            placeholder="example@email.com"
            form={form}
            path="email"
          />
          <div className="form-actions sign-up-actions">
            <Button isLoading={form.isLoading || isLoggingOut.isOpen} type="submit" tabIndex={1} className="highlight with-loader">Recover
              password</Button>
          </div>
          <Errors form={form}/>
          {
            successFeedback.isOpen &&
            <ul className="successContainer">
              <li>
                <span>Recovery e-mail sent successfully.</span>
                <span className="icon icon-x" onClick={successFeedback.close}/>
              </li>
            </ul>
          }
        </Form>
      </div>
    )
  }
}

export function PasswordRecoveryFooter() {return (
  <div className="signup-question"><span>Remember your password?</span><Link className="button outline" to="/">Sign
    in</Link></div>)
}

export const PasswordRecovery = () => <SignInLayout Content={PasswordRecoveryContent} Footer={PasswordRecoveryFooter}/>



// WEBPACK FOOTER //
// ./src/javascripts/signin/PasswordRecovery.jsx